/**
 * HTTP Status codes used across the application
 */
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500
};

/**
 * Checks if an HTTP response status indicates success (200 or 201)
 * @param {number} status - The HTTP status code
 * @returns {boolean} - True if the status indicates success
 */
export const isSuccessResponse = (status) => {
  return status === HTTP_STATUS.OK || status === HTTP_STATUS.CREATED;
};

export const STANDARD_ERROR_MESSAGE = 'Sorry, something went wrong. Please try again.';

export default HTTP_STATUS;
